import Login from "./Login";

const AdminLogin = () => {
	return <Login isAdmin />;
};

export default AdminLogin;
